import { gql } from '@apollo/client';

export const TOGGLE_THREAD_MUTE = gql`
    mutation toggleThreadMute($rootPostId: ID!) {
        toggleThreadMute(rootPostId: $rootPostId)
    }
`;
